import { render, staticRenderFns } from "./DashboardElement.vue?vue&type=template&id=fccd1da6&scoped=true&"
import script from "./DashboardElement.vue?vue&type=script&lang=ts&"
export * from "./DashboardElement.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardElement.vue?vue&type=style&index=0&id=fccd1da6&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fccd1da6",
  null
  
)

export default component.exports